




















import { defineComponent, ref, computed, PropType } from "@vue/composition-api";
import { ContentFile } from "@scrile/api-provider/dist/api/ContentFilesProvider";
import { MediaFilesController } from "@/lib/MediaFilesController";
import BaseIcon from "@/components/BaseIcon";
import { ProcessedContentFiles } from "@/components/ContentFeedItem";
import PostFileList from "@/components/PostFileList";

export default defineComponent({
  name: "ContentFeedFileList",
  components: { PostFileList, BaseIcon },
  props: {
    fileList: { type: Object as PropType<ProcessedContentFiles>, required: true },
  },
  setup(props) {
    const showAllFiles = ref(false);
    const filesToPrint = computed(() =>
      showAllFiles.value ? props.fileList.accessed : props.fileList.accessed.slice(0, 3)
    );
    const getDownloadUrl = (file: ContentFile) => {
      return MediaFilesController.getFileUrl(file.urlPart);
    };

    return {
      showAllFiles,
      filesToPrint,
      getDownloadUrl,
    };
  },
});
